<template>
  <v-row class="align-stretch" justify="start" align-content="start">
    <v-col cols="12" sm="6">
      <SingleValueChart
          :title="$t('components.AIAutoDialerDashboard.TotalDialsLabel')"
          :data="stats.total_dials"
          :loading="loading" :report-mode="reportMode"/>
    </v-col>
    <v-col cols="12" sm="6">
      <SingleValueChart
          :title="$t('components.AIAutoDialerDashboard.UniqueCallersLabel')"
          :data="stats.unique_callers"
          :loading="loading" :report-mode="reportMode"/>
    </v-col>
  </v-row>
</template>

<script>
import SingleValueChart from '@/components/dashboard/charts/SingleValueChart';


export default {
  name: 'TextToPayKPIs',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    kpis: {
      type: Object,
      required: true
    },
    reportMode: {
      type: String,
      required: false,
      default: null
    }
  },
  data: () => ({
    stats: {
      total_dials: 0,
      unique_callers: 0
    },
  }),
  methods: {
    updateStats(data) {
      if (data) {
        this.stats = data;
      }
    },
  },
  watch: {
    kpis(value) {
      this.updateStats(value);
    }
  },
  components: {SingleValueChart}
}
</script>